document.addEventListener("DOMContentLoaded", function () {
    const sectionContentStart = document.querySelectorAll(".js-content-start");

    gsap.utils.toArray(sectionContentStart).forEach((contentStart) => {

        const contentPin = contentStart.querySelector(".js-content-pin");

        // let elementHeight = contentPin.offsetHeight + 60;

        ScrollTrigger.matchMedia({
            "(min-width: 650px)": function() {
              // setup animations and ScrollTriggers for screens 950px wide or greater...
              // These ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
                ScrollTrigger.create({
                    trigger: contentStart,
                    start: () => "top top",
                    // end: self => "+=" + (document.querySelector(".js-media-pin").offsetHeight - self.pin.offsetHeight),
                    end: self => "bottom " + (self.pin.offsetHeight + 110),
                    pin: contentPin,
                    pinSpacing: false
                    // markers: true
                });

                //images loaded w/ scroll trigger refresh
                //enseures maths is right once content is loaded
                var imgLoad = imagesLoaded( contentStart );
                imgLoad.on( 'progress', function( instance, image ) {
                    var result = image.isLoaded ? 'loaded' : 'broken';
                    // console.log( 'image is ' + result + ' for ' + image.img.src );
                    ScrollTrigger.refresh();
                });
            },
        }); 
    });
});
